import { useState, useEffect, type FC } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { markdownComponents, urlTransform } from "../utils/markdownComponents";

interface TypewriterEffectProps {
  content: string;
  onChange: () => void;
  onFinished: () => void;
  className?: string;
}

const TypewriterEffect: FC<TypewriterEffectProps> = ({ content, onChange, onFinished, className = "" }) => {
  const [displayedContent, setDisplayedContent] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (currentIndex < content.length) {
        setDisplayedContent(content.substring(0, currentIndex + 1));
        setCurrentIndex(currentIndex + 1);
        // `setTimeout` used to ensure DOM is updated before scroll attempt
        setTimeout(onChange, 0);
      } else {
        onFinished();
      }
    }, 3); // Adjust the delay (in milliseconds) for typing speed

    return () => clearTimeout(timeoutId);
  }, [currentIndex, content, onChange, onFinished]);

  return (
    <div className={className}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents} urlTransform={urlTransform}>
        {displayedContent}
      </ReactMarkdown>
    </div>
  );
};

export default TypewriterEffect;
